import {createFileRoute, Navigate} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/esports/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/esports/leagues/" />;
}
